export default __webpack_public_path__ + "static/agak-a1edc649d811c88773a1020d05871d23.webp";